let nav = document.querySelector('.nav')

window.onscroll = function changeNav () {
  (window.scrollY > 90) ? nav.classList.add('is-active') : nav.classList.remove('is-active')
}
